module.exports = __webpack_public_path__ + "static/img/reward.38989b2f.png";